<template>
  <div class="content">
    <v-row class="search_box">
      <v-col>
        <topNav></topNav>
      </v-col>
    </v-row>
    <div class="main_container">
      <div class="md_title mart24 marb12">企业管理</div>
      <v-row>
        <v-col>
          <div class="firm_list_wrapper">
            <div class="firm_list_top">
              <div class="top_left">
                <div v-if="!viewComp" class="common_input_style">
                  <v-text-field
                    label=""
                    placeholder="请输入企业名称"
                    outlined
                    v-model="companyName"
                    @keydown.enter="getResult"
                    @click:append="getResult"
                    append-icon="mdi-magnify"
                    dense
                  ></v-text-field>
                </div>
              </div>
              <div class="top_right">
                <!-- <div   class="btn_item btn1" @click="sortChange('desc')">查看企业排行榜</div> -->
                <!-- <div class="btn_item btn1 hoverBtn"
                     style="margin-righbtn_itemt:none;"
                     @click="btnChange"> -->
                <!-- <i class="icon chart_icon"></i> -->
                <!-- manger_tag -->
                <!-- <v-icon>mdi-white-balance-sunny</v-icon> -->
                <!-- <div class="tag"></div>
                        查看企业排行榜
                        </div> -->
                <!-- <div class="btn_item btn1 hoverBtn" @click="addCompany">新增企业</div>
                        <div class="btn_item  btn2 hoverBtn">批量新增</div> -->
                <div class="btn_item btn1 hoverBtn" @click="btnChange">
                  <span class="tag"></span
                  ><span class="text">查看企业排行榜</span>
                </div>
              </div>
            </div>
            <div class="firm_list_center">
              <div v-if="!viewComp">
                <v-data-table
                  v-model="selectKeys"
                  item-key="name"
                  :headers="headers"
                  :items="list"
                  class="common_table"
                  @click:row="rowClicktable"
                  :items-per-page="itemsPerPage"
                  hide-default-footer
                >
                  <template v-slot:[`item.index`]="{ item }">
                    <div>{{ item.index }}</div>
                  </template>
                  <template v-slot:[`item.createdAt`]="{ item }">
                    <div>
                      <span>{{ timeFormat(item.createdAt) }}</span>
                    </div>
                  </template>
                  <template v-slot:[`item.option`]="{ item }">
                    <div style="max-width: 230px" class="actions_text">
                      <v-btn
                        x-small
                        color="#0095FF"
                        height="22"
                        outlined
                        border="1px solid #0095FF"
                        dark
                        @click="gongshangCompany(item.id)"
                      >
                        工商
                      </v-btn>
                      <v-btn
                        x-small
                        color="#33D1B1"
                        height="22"
                        outlined
                        border="1px solid #33D1B1"
                        style="margin-left: 23px"
                        dark
                        @click="zhishiCompany(item.name, item.id)"
                      >
                        知产
                      </v-btn>
                    </div>
                  </template>
                </v-data-table>
                <!---第一个分页-->
              </div>
              <div v-if="viewComp">
                <v-data-table
                  item-key="companyName"
                  single-select
                  hide-default-footer
                  :headers="headers1"
                  :items="list1"
                  :items-per-page="15"
                  disable-sort
                  class="common_table"
                >
                  <template v-slot:[`item.index`]="{ item }">
                    <div>{{ item.index }}</div>
                  </template>
                  <template v-slot:[`header.numPa`]="{ header }">
                    <div>
                      <span>{{ header.text }}</span>
                      <span v-if="sort == 'asc'" @click="sortChange('desc')">
                        <v-icon>mdi-menu-down</v-icon>
                      </span>
                      <span v-if="sort == 'desc'" @click="sortChange('asc')">
                        <v-icon>mdi-menu-up</v-icon>
                      </span>
                    </div>
                  </template>
                  <template v-slot:[`header.numTm`]="{ header }">
                    <div>
                      <span>{{ header.text }}</span>
                      <span v-if="sort1 == 'asc'" @click="numTmTitle('desc')">
                        <v-icon>mdi-menu-down</v-icon>
                      </span>
                      <span v-if="sort1 == 'desc'" @click="numTmTitle('asc')">
                        <v-icon>mdi-menu-up</v-icon>
                      </span>
                    </div>
                  </template>
                  <template v-slot:[`header.numRz`]="{ header }">
                    <div>
                      <span>{{ header.text }}</span>
                      <span v-if="sort2 == 'asc'" @click="numRzTitle('desc')">
                        <v-icon>mdi-menu-down</v-icon>
                      </span>
                      <span v-if="sort2 == 'desc'" @click="numRzTitle('asc')">
                        <v-icon>mdi-menu-up</v-icon>
                      </span>
                    </div>
                  </template>
                  <template v-slot:[`header.numIc`]="{ header }">
                    <div>
                      <span>{{ header.text }}</span>
                      <span v-if="sort3 == 'asc'" @click="numIcTitle('desc')">
                        <v-icon>mdi-menu-down</v-icon>
                      </span>
                      <span v-if="sort3 == 'desc'" @click="numIcTitle('asc')">
                        <v-icon>mdi-menu-up</v-icon>
                      </span>
                    </div>
                  </template>
                  <template v-slot:[`header.numSrProd`]="{ header }">
                    <div>
                      <span>{{ header.text }}</span>
                      <span
                        v-if="sort4 == 'asc'"
                        @click="numSrProdTitle('desc')"
                      >
                        <v-icon>mdi-menu-down</v-icon>
                      </span>
                      <span
                        v-if="sort4 == 'desc'"
                        @click="numSrProdTitle('asc')"
                      >
                        <v-icon>mdi-menu-up</v-icon>
                      </span>
                    </div>
                  </template>
                </v-data-table>
              </div>
              <!--第一个分页-->
              <div v-if="!viewComp" class="hist_pagination">
                <v-row>
                  <v-col class="common_pagePase left">
                    <!-- <span class="text hidden-xs-only">共{{ pageLength }}条记录</span> -->
                    <v-pagination
                      v-model="currentPageOne"
                      :length="pageLength"
                      :total-visible="pageVisible"
                    >
                    </v-pagination>
                  </v-col>
                </v-row>
              </div>
              <!--第二个分页-->
              <div v-if="viewComp" class="hist_pagination">
                <v-row>
                  <v-col class="common_pagePase left">
                    <span class="text hidden-xs-only"
                      >共{{ pageLengthTwo }}条记录</span
                    >
                    <v-pagination
                      v-model="currentPage"
                      :length="pageLengthTwo"
                      :total-visible="pageVisible"
                    >
                    </v-pagination>
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <!--工商信息-->
    <v-dialog
      v-model="informationVisible"
      width="1000"
      class="industrial"
      height="611px"
    >
      <v-card>
        <v-card-title class="lighten-2"
          >工商信息
          <v-icon @click="informationCancel">mdi-close</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-title style="margin-top: 15px"
          >{{ gongshang.name }}
        </v-card-title>
        <div class="bartaber fontTitle">
          <span
            style="
              font-size: 12px !important;
              color: #33d1b1;
              border: 1px solid #33d1b1;
              ling-height: 22px;
              margin-left: 24px;
              padding: 2px 8px;
              border-radius: 4px;
            "
            >{{ gongshang.new_status }}</span
          >
          <span
            v-if="sr"
            style="
              font-size: 12px !important;
              color: #ffb217;
              border: 1px solid #ffb217;
              ling-height: 22px;
              margin-left: 15px;
              padding: 2px 8px;
              border-radius: 4px;
            "
            >双软</span
          >
          <!-- <span></span> -->
          <span
          v-if="gx"
            style="
              font-size: 12px !important;
              color: #0095ff;
              border: 1px solid #0095ff;
              ling-height: 22px;
              margin-left: 15px;
              padding: 2px 8px;
              border-radius: 4px;
            "
            >高新企业</span
          >
        </div>
        <v-card-text>
          <table
            style="border-collapse: collapse"
            borderColor="#E1E5EB"
            height="42"
            cellPadding="1"
            width="952"
            align="center"
            border="1"
          >
            <tbody>
              <tr style="line-height: 42px; width: 144px">
                <td style="padding-left: 14px; color: #777c8b">法定代表人</td>
                <td style="padding-left: 14px">{{ gongshang.operName }}</td>
                <td style="padding-left: 14px; color: #777c8b">经营状态</td>
                <td style="padding-left: 14px">{{ gongshang.econKind }}</td>
              </tr>
              <tr style="line-height: 42px">
                <td style="padding-left: 14px; color: #777c8b">注册资本</td>
                <td style="padding-left: 14px">{{ gongshang.registCapi }}</td>
                <td style="padding-left: 14px; color: #777c8b">实缴资本</td>
                <td style="padding-left: 14px">{{ gongshang.actualCapi }}</td>
              </tr>
              <tr style="line-height: 42px">
                <td style="padding-left: 14px; color: #777c8b; width: 144px">
                  统一社会信用代码
                </td>
                <td style="padding-left: 14px">{{ gongshang.creditNo }}</td>
                <td style="padding-left: 14px; color: #777c8b">纳税人识别号</td>
                <td style="padding-left: 14px">{{ gongshang.creditNo }}</td>
              </tr>
              <tr style="line-height: 42px">
                <td style="padding-left: 14px; color: #777c8b">工商注册号</td>
                <td style="padding-left: 14px">{{ gongshang.orgNo }}</td>
                <td style="padding-left: 14px; color: #777c8b">组织机构代码</td>
                <td style="padding-left: 14px">{{ gongshang.orgNo }}</td>
              </tr>
              <tr style="line-height: 42px">
                <td style="padding-left: 14px; color: #777c8b">成立日期</td>
                <td style="padding-left: 14px">{{ gongshang.startDate }}</td>
                <td style="padding-left: 14px; color: #777c8b">营业期限</td>
                <td style="padding-left: 14px">
                  {{ gongshang.startDate }}-{{ gongshang.termEnd }}
                </td>
              </tr>
              <tr style="line-height: 42px">
                <td style="padding-left: 14px; color: #777c8b">核对日期</td>
                <td style="padding-left: 14px">{{ gongshang.checkDate }}</td>
                <td style="padding-left: 14px; color: #777c8b">注册地址</td>
                <td style="padding-left: 14px">
                  {{ gongshang.address }}
                </td>
              </tr>
              <tr>
                <td style="padding-left: 16px; color: #777c8b" colspan="1">
                  经营范围
                </td>
                <td style="padding-left: 16px; padding: 10px 10px" colspan="3">
                  {{ gongshang.scope }}
                </td>
              </tr>
              <tr></tr>
            </tbody>
          </table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addVisible" width="500">
      <v-card>
        <v-card-title class="lighten-2">{{ visibleTit }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <div class="h36">
                    <v-text-field
                      v-model="form.name"
                      label=""
                      required
                      outlined
                      :dense="true"
                      placeholder="请输入公司名称"
                    ></v-text-field>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div class="h36">
                    <v-text-field
                      v-model="form.contact"
                      label=""
                      required
                      outlined
                      :dense="true"
                      placeholder="请输入联系人"
                    ></v-text-field>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div class="h36">
                    <v-text-field
                      v-model="form.contactPhone"
                      label=""
                      required
                      outlined
                      :dense="true"
                      placeholder="请输入联系方式"
                    ></v-text-field>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="handleAddCancel">取消</v-btn>
          <v-btn
            color="primary"
            @click="handleAddOk"
            v-if="visibleTit == '添加企业'"
          >
            确定
          </v-btn>
          <v-btn
            color="primary"
            @click="handleEditOk"
            v-if="visibleTit == '修改企业'"
          >
            确定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--查看详情-->
    <v-dialog v-model="detailVisible" width="500">
      <v-card>
        <v-card-title class="lighten-2">{{ visibleTit }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <div class="h36">
                    <v-text-field
                      v-model="form.name"
                      label=""
                      required
                      outlined
                      :dense="true"
                      placeholder="请输入公司名称"
                    ></v-text-field>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div class="h36">
                    <v-text-field
                      v-model="form.contact"
                      label=""
                      required
                      outlined
                      :dense="true"
                      placeholder="请输入联系人"
                    ></v-text-field>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div class="h36">
                    <v-text-field
                      v-model="form.contactPhone"
                      label=""
                      required
                      outlined
                      :dense="true"
                      placeholder="请输入联系方式"
                    ></v-text-field>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="handleDetailCancel">取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import topNav from "@/components/widgets/topNav.vue";
import companyList from "../../assets/company.json";
import { mapActions } from "vuex";
import Qs from "qs";
export default {
  data() {
    return {
      items: [
        {
          text: "企业管理",
          disabled: false,
          href: "/manager#/manage",
        },
        {
          text: "知识产权信息",
          disabled: false,
          href: "/manager#/knowledge",
        },
      ],
      page: 1, //当前页面号
      itemsPerPage: 15, //每页条目数
      pageLength: 0, //总页面数
      pageLengthTwo: 0,
      pageVisible: 7, //分页条中可见页面号数
      viewComp: false,
      detailVisible: false,
      sort: "desc",
      sort1: "desc",
      sort2: "desc",
      sort3: "desc",
      sort4: "desc",
      sort5: "desc",
      gx:'',
      sr:'',
      list: [],
      selectKeys: [],
      addVisible: false,
      visibleTit: "添加企业",
      informationVisible: false, //工商信息
      itemsPerPageAllText: "",
      currentPage: 1,
      currentPageOne: 1,
      pageSize: 15,
      form: {},
      companyName: "",
      name: "",
      gongshang: {}, //工商信息的弹窗
      currentParams: {
        params: {
          gid: 1,
          page: this.currentPage,
          pageSize: this.pageSize,
          sortField: "pa",
          sortDirection: "asc",
        },
      },
      currentParamsOne: {
        params: {
          gid: 1,
          page: this.currentPageOne,
          pageSize: this.pageSize,
        },
      },
      headers: [
        { text: "序号", value: "index", sortable: false },
        { text: "企业名称", value: "name", sortable: false },
        { text: "专利数", width: "20%", value: "numPa", sortable: false },
        { text: "操作", width: "15%", value: "option", sortable: false },
      ],
      headers1: [
        { text: "序号", value: "index", sortable: false },
        {
          text: "企业名称",
          width: "20%",
          value: "companyName",
          sortable: false,
        },
        { text: "专利榜", value: "numPa", sortable: false },
        { text: "商标榜", value: "numTm", sortable: true },
        { text: "软著榜", value: "numRz", sortable: true },
        { text: "集成电路榜", value: "numIc", sortable: true },
        { text: "软件产品榜", value: "numSrProd", sortable: true },
      ],

      list1: [
        {
          companyName: "",
          numPa: "",
          numTm: "",
          numRz: "",
          numIc: "",
          numSrProd: "",
        },
      ],
      desserts: [
        {
          name: "法定代表人",
          calories: "王升",
        },
        {
          name: "注册资本",
          calories: "44950.50万人民币",
        },
        {
          name: "统一社会信用代码",
          calories: "91310117086231052A",
        },
        {
          name: "工商注册号",
          calories: "310114002636262",
        },
        {
          name: "成立日期",
          calories: "2013-12-23",
        },
        {
          name: "核对日期",
          calories: "2021-12-28",
        },
        {
          name: "Lollipop",
          calories: 392,
        },
      ],
    };
  },
  computed: {},
  mounted() {
    this.getList();
    this.sortList();
  },
  watch: {
    // currentPage(val) {
    // 	this.getList()
    // 	this.sortList()

    // }
    currentPage() {
      this.sortList();
      // this.getResult()//搜索查询
    },
    currentPageOne() {
      this.getList();
    },
  },
  components: {
    topNav,
  },
  created() {
    this.getList();
  },
  methods: {
    //第一个列表的页面
    rowClicktable: function (item, row) {
      row.select(true);
      let codes = this.list.map((item) => {
        return item.name;
      });
      let value = codes.join(" OR ");
      let temp = "ap:( " + item.name + " )";
      this.$router.push({
        // path: "/search/result",
        query: {
          str: temp,
        },
      });
    },

    //列表的数据
    ...mapActions("manage", [
      "getCompanies",
      "getmanageUpdate",
      "getmanageManageAdd",
      "getmanageManageDelete",
      "getmanageManageSearch",
      "getmanageCompanyindex",
      "getManageEnterprise", //工商信息
      // 'getmanageManagePatent',//专利信息
    ]),
    getList() {
      let _this = this;
      let data = {
        params: {
          gid: 1,
          page: this.currentPageOne,
          pageSize: this.pageSize,
          names: this.companyName,
        },
      };

      this.getCompanies({
        data: data,
        handle(res) {
          let list = res.message;
          _this.list = res.message.data;
          _this.pageLength = parseInt(res.message.pages);
        },
      });
    },
    //查看排行的table
    btnChange() {
      this.$router.push({
        path: "/enteRaing",
      });
    },
    //点击table表格的数据
    //专利榜得接口数据
    sortChange(val) {
      console.log(val);
      this.currentPageOne = 1;
      this.sort = val;
      let _this = this;
      let data = {
        params: {
          gid: 1,
          page: this.currentPage,
          pageSize: this.pageSize,
          sortField: "pa",
          sortDirection: this.sort,
        },
      };
      this.currentParams = data;
      this.getmanageCompanyindex({
        data: data,
        handle(res) {
          let list = res.message;
          _this.list1 = res.message.data;
          _this.pageLengthTwo = parseInt(res.message.pages);
        },
      });
      this.currentPage = 1;
      this.list1 = [];
      this.pageLengthTwo = "";
    },
    //分页的调用

    //商标榜的数据
    numTmTitle(val) {
      this.sort1 = val;
      let _this = this;
      let data = {
        params: {
          gid: 1,
          page: this.currentPage,
          pageSize: this.pageSize,
          sortField: "tm",
          sortDirection: this.sort1,
        },
      };
      this.currentParams = data;
      this.getmanageCompanyindex({
        data: data,
        handle(res) {
          // console.log(res, '===res===')
          let list = res.message;
          _this.list1 = res.message.data;
          _this.pageLengthTwo = parseInt(res.message.pages); //商标的分页
        },
      });
    },
    //软著榜的数据
    numRzTitle(val) {
      this.sort2 = val;
      let _this = this;
      let data = {
        params: {
          gid: 1,
          page: this.currentPage,
          pageSize: this.pageSize,
          sortField: "rz",
          sortDirection: this.sort2,
        },
      };
      this.currentParams = data;
      this.getmanageCompanyindex({
        data: data,
        handle(res) {
          let list = res.message;
          _this.list1 = res.message.data;
          _this.pageLengthTwo = parseInt(res.message.pages);
        },
      });
    },

    //工商信息
    gongshangCompany(id) {
      console.log(id, "======id=");
      this.informationVisible = true;
      let _this = this;
      let data = {
        params: {
          companyId: id,
        },
      };
      this.getManageEnterprise({
        data: data,
        handle(res) {
          _this.listed = res.message;
          _this.gx = res.message.data.gx;
         _this.sr= res.message.data.sr;
          _this.gongshang = res.message.data.info;

       
        },
      });
    },

    //工商按取消得按钮
    informationCancel() {
      this.informationVisible = false;
    },
    //
    numIcTitle(val) {
      this.sort3 = val;
      let _this = this;
      let data = {
        params: {
          gid: 1,
          page: this.currentPage,
          pageSize: this.pageSize,
          sortField: "ic",
          sortDirection: this.sort3,
        },
      };
      this.currentParams = data;
      this.getmanageCompanyindex({
        data: data,
        handle(res) {
          // console.log(res, '===res===')
          let list = res.message;
          _this.list1 = res.message.data;
          _this.pageLengthTwo = parseInt(res.message.pages);
        },
      });
    },

    //知产信息
    zhishiCompany(name, id) {
      this.$router.push({
        path: "/knowledge",
        query: {
          name: name,
          id: id,
        },
      });
    },

    numSrProdTitle(val) {
      this.sort4 = val;
      let _this = this;
      let data = {
        params: {
          gid: 1,
          page: this.currentPage,
          pageSize: this.pageSize,
          sortField: "sr_prod",
          sortDirection: this.sort4,
        },
      };
      this.currentParams = data;
      this.getmanageCompanyindex({
        data: data,
        handle(res) {
          // console.log(res, '===res===')
          let list = res.message;
          _this.list1 = res.message.data;
          //_this.pageLength = parseInt(res.message.pages)
          _this.pageLengthTwo = parseInt(res.message.pages);
        },
      });
    },
    //第二个排序的接口
    sortList() {
      let _this = this;
      let data = this.currentParams;
      data.params.page = this.currentPage;
      this.getmanageCompanyindex({
        data: data,
        handle(res) {
          let list = res.message;
          _this.list1 = res.message.data;
          _this.pageLengthTwo = parseInt(res.message.pages);
        },
      });
    },

    timeFormat(unixTime) {
      let date = new Date(unixTime);
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D = date.getDate() + " ";
      let h = date.getHours() + ":";
      let m = date.getMinutes() + ":";
      let s = date.getSeconds();
      return Y + M + D + h + m + s;
    },

    successMsg(msg) {
      this.$message({
        type: "success",
        message: msg || "操作成功!",
      });
    },
    failMsg(msg) {
      this.$message({
        type: "error",
        message: msg || "请填写信息!",
      });
    },
    //
    //搜索企业的名称
    getResult() {
      let _this = this;
      let data = {
        params: {
          names: this.companyName,
          page: this.currentPage,
          pageSize: this.pageSize,
        },
      };
      this.getmanageManageSearch({
        data: data,
        handle(res) {
          let list = res.message;
          _this.list = res.message.data;
          _this.pageLength = parseInt(res.message.pages);
        },
      });
    },
    addCompany() {
      this.form = {};
      this.addVisible = true;
      this.visibleTit = "添加企业";
    },
    editCompany(value) {
      this.addVisible = true;
      this.form = value;
      this.visibleTit = "修改企业";
    },
    //查看详情的功能
    detailsCompany(value) {
      this.detailVisible = true;
      this.form = value;
      this.visibleTit = "查看企业";
    },
    //详情的关闭
    handleDetailCancel() {
      this.detailVisible = false;
    },

    handleAddCancel() {
      this.addVisible = false;
    },
    async onPageChange(page) {
      this.page = page;
      await this.getList();
    },
    handleAddOk() {
      // this.addVisible = false
      let data = {
        params: this.form,
      };
      let _this = this;
      this.getmanageManageAdd({
        data: data,
        handle(res) {
          if (res.success) {
            _this.successMsg(res.message);
            _this.addVisible = false;
            _this.getList();
          } else {
            _this.failMsg(res.message);
          }
        },
      });
    },
    handleEditOk() {
      let data = {
        params: {
          id: this.form.id,
          user: this.form.user,
          name: this.form.name,
          contact: this.form.contact,
          contactPhone: this.form.contactPhone,
          description: this.form.description,
        },
      };
      let _this = this;
      //编辑的接口
      this.getmanageUpdate({
        data: data,
        handle(res) {
          _this.addVisible = false;
          if (res.success) {
            _this.successMsg(res.message);
            _this.getList();
          } else {
            _this.failMsg(res.message);
          }
        },
      });
    },
    //删除的table数据
    historyItemDel(id, val) {
      if (val == "list") {
        id = id.map((item) => {
          return item.id;
        });
      }
      let ids = id.join(",");
      this.$msgbox
        .confirm("此操作将永久删除该记录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          let data = {
            params: {
              ids: ids,
            },
          };
          let _this = this;
          this.getmanageManageDelete({
            data: data,
            handle(res) {
              if (res.success) {
                _this.$message({
                  type: "success",
                  message: res.message || "操作成功",
                });
                _this.getList();
              }
            },
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>
